import { useCallback, useContext } from "react";
import { StoreContext } from "../store/Store";
import { GlobalRefContext } from "../store/GlobalRefs";
import {
  Background,
  BackgroundVariant,
  ReactFlow,
  applyEdgeChanges,
  applyNodeChanges,
  useReactFlow,
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import { CustomNode } from "../components/custom/CustomNode";
import { CustomEdge } from "../components/custom/CustomEdge";
import { StartNode } from "../components/custom/StartNode";
import { DragNode } from "../components/custom/DragNode";
import { PlaceholderNode } from "../components/custom/PlaceholderNode";
import { actionTypes } from "../store/storeTypes";
import Logo from "../images/svg/Logo";
// import Logo_png from "../images/logo.png"

const debug = false;

const nodeTypes = {
  CustomNode: CustomNode,
  StartNode: StartNode,
  PlaceholderNode: PlaceholderNode,
  DragNode: DragNode,
};
const edgeTypes = { CustomEdge: CustomEdge };

const maxZoomOnFocus = 1.2;

export const FlowChart = () => {
  const [store, dispatch] = useContext(StoreContext);
  const grefs = useContext(GlobalRefContext);
  const { audit_flowSelection, edges, mode, nodes } = store;
  const { fitView, getIntersectingNodes } = useReactFlow();

  const onNodesChange = useCallback(
    (changes) => {
      if (debug) {
        console.log("onNodesChange");
      }

      if (debug) {
        console.log("change nodes");
      }
      const dimchanges = changes.filter(
        (change) =>
          change.type === "dimensions" ||
          grefs.dragNode.current ||
          mode === "layout"
      );
      if (dimchanges.length > 0) {
        const newNodes = applyNodeChanges(changes, nodes);
        dispatch({ type: actionTypes.SET_NODES, payload: newNodes });
      }
      // }
      if (!grefs.dragNode.current) {
        changes.forEach((change) => {
          if (
            change.type === "dimensions" &&
            grefs.focusRef.current === change.id &&
            change.dimensions &&
            change.dimensions.height > 0 &&
            change.dimensions.width > 0
          ) {
            fitView({
              nodes: [{ id: grefs.focusRef.current }],
              duration: 500,
              maxZoom: maxZoomOnFocus,
            });

            grefs.focusRef.current = null;
          }
        });
      }
    },
    [
      dispatch,
      nodes,
      // grefs.ignoreNodeChange,
      fitView,
      grefs.focusRef,
      grefs.dragNode,
      mode,
    ]
  );
  const onEdgesChange = useCallback(
    (changes) => {
      const newEdges = applyEdgeChanges(changes, edges);
      dispatch({ type: actionTypes.SET_EDGES, payload: newEdges });
    },
    [dispatch, edges]
  );
  const onInit = useCallback(() => {
    if (mode === "flow") {
      if (debug) {
        console.log("init");
      }
      dispatch({
        type: actionTypes.SET_FOCUSID,
        payload: grefs.startRef.current,
      });
    }
  }, [dispatch, grefs.startRef, mode]);
  const onNodeDragStart = (evt, node) => {
    // grefs.dragNode.current = node;
    if (mode === "layout") return;
    grefs.dragNode.current.action = "start";
  };
  const onNodeDrag = (evt, node) => {
    if (mode === "layout") return;
    // find overlapping nodes
    const intersectingNodes = getIntersectingNodes(node);
    grefs.dragNode.current.node = intersectingNodes
      ? intersectingNodes[0]
      : null;
  };
  const onNodeDragStop = (evt, node) => {
    if (mode === "layout") return;

    let newNodes = [];

    if (grefs.dragNode.current && grefs.dragNode.current.node) {      

      //Find all nodes to remove
      let deleteindexes = [];
      const walkEdges = (id) => {
        const found = edges
          .filter((edge) => edge.source === id && edge.target)
          .map((item) => item.target);
        if (found.length === 0) return;
        deleteindexes = deleteindexes.concat(found);
        found.forEach((item) => {
          walkEdges(item);
        });
      };
      walkEdges(grefs.dragNode.current.node.id);
      newNodes = nodes.filter((node) => {
        return node.id !== "floatNode" && !deleteindexes.includes(node.id);
      });
      deleteindexes.forEach((index) => {
        delete grefs.selectedRef.current[index];
      });

      //removeaudit items
      let deleteAuditItems = [];
      deleteindexes.push(grefs.dragNodeParent.current);
      deleteindexes.forEach((index) => {
        const auditItems = edges
          .filter((edge) => {
            return edge.target === index;
          })
          .map((ed) => {
            return ed.source;
          });
        deleteAuditItems = deleteAuditItems.concat(auditItems);
      });

      grefs.auditTrail.current = grefs.auditTrail.current.filter((node) => {
        return !deleteAuditItems.includes(node.nodeId);
      });
    } else {
      newNodes = nodes.filter((node) => {
        return node.id !== "floatNode";
      });
    }

    grefs.ignoreNodeChange.current = true;
    grefs.dragNode.current = null;
    grefs.dragNodeParent.current = null;
    dispatch({ type: actionTypes.SET_NODES, payload: newNodes });
  };

  return (mode === "flow" && audit_flowSelection === "Flow") ||
    mode === "layout" ? (
    <div
      style={{
        width: "100%",
        flexGrow: 1,
        flexStretch: 0,
        flexBasis: "auto",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "50%",
          // border:"1px solid red",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // backgroundColor:"pink"
        }}
      >
        <Logo height={200} width={400} />
        {/* <img alt="logo" src={Logo_png}/> */}
      </div>

      <ReactFlow
        snapToGrid
        snapGrid={[25, 25]}
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onInit={onInit}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        fitView={true}
        maxZoom={2} //2
        minZoom={0.1} //0.5 onNodeDragStart={onNodeDragStart}
        onNodeDragStart={onNodeDragStart}
        onNodeDrag={onNodeDrag}
        onNodeDragStop={onNodeDragStop}
      >
        <Background color="red" variant={BackgroundVariant.Dots} />
      </ReactFlow>
    </div>
  ) : null;
};
